export function ArrowHeadIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="4"
      height="7"
      viewBox="0 0 4 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 6.97727L2.18182 3.45455H3.47727V3.56818L1.18182 6.97727H0ZM0 0L1.18182 0L3.47727 3.40909V3.52273H2.18182L0 0Z"
        fill="currentColor"
      />
    </svg>
  );
}
